import { render } from "./Switch2FAModal.vue?vue&type=template&id=1decc251"
import script from "./Switch2FAModal.vue?vue&type=script&lang=js"
export * from "./Switch2FAModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__